<template>
  <div class="info-card">
    <div class="info-card__top">
      <img :src="faculty.img" alt="">
      <h3 class="info-card__name">{{ faculty.name }}</h3>
    </div>
    <div class="info-card__bottom">
      <div class="info-card__title">Kayıtlı Öğrenci Yurdu</div>
      <div class="info-card__count">{{ faculty.count }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UniSearchCard',
  props: {
    faculty: Object
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/components/info-card";
  .info-card {
    opacity: 1;
    background: #f4f7fb;

    &__name {
      color: #4b5ba4;
      padding: 0 25px;
      line-height: 1.4em;
      font-size: 18px;
      transition: color .3s ease-in-out;
    }

    &:hover {
      .info-card__name {
        color: #17d3a5;
      }
      .info-card__count {
        color: #535b78;
      }
      .info-card__title {
        color: #656e8d;
      }
    }

  }
</style>
